import React from 'react';
import Lottie from 'react-lottie';

// Magnifying glass animation data
import magnifyingGlassAnimation from './animation.json';
const VerificationStartScreen = () => {
  const defaultOptions = {
    loop: true,
    autoplay: true,
    animationData: magnifyingGlassAnimation,
    rendererSettings: {
      preserveAspectRatio: 'xMidYMid slice'
    }
  };

  const handleGetStarted = () => {
    console.log('Get Started clicked');
    // Add your navigation logic here
  };

  const handleAlreadyHaveAccount = () => {
    console.log('Already have an account clicked');
    // Add your navigation logic here
  };

  return (
    <div className="bg-white mt-[5rem]">
      <div className="w-full bg-white overflow-hidden text-center">

        {/* Header */}
        <div className="px-6 pt-8 pb-4 text-center">
          <h1 className="text-[#417175] text-center text-[30px]  font-bold mb-2">
            Let's Get Started With Your Verification!
          </h1>
        </div>

        {/* Animation Container */}
        <div className="px-6 py-8 flex justify-center mt-2">
          <div>
            <Lottie
              options={defaultOptions}
              height={400}
              width={400}
              isStopped={false}
              isPaused={false}
            />
          </div>
        </div>

        <h3 className="text-[#417175] text-center text-[16px] mt-2 font-bold mb-2">
          Please wait...
        </h3>

      </div>
    </div>

  );
};

export default VerificationStartScreen;